/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessUnitResponse
 */
export interface BusinessUnitResponse {
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitResponse
     */
    name: string;
}

/**
 * Check if a given object implements the BusinessUnitResponse interface.
 */
export function instanceOfBusinessUnitResponse(value: object): value is BusinessUnitResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BusinessUnitResponseFromJSON(json: any): BusinessUnitResponse {
    return BusinessUnitResponseFromJSONTyped(json, false);
}

export function BusinessUnitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
    };
}

export function BusinessUnitResponseToJSON(value?: BusinessUnitResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

